// This action is dispatched once at store instantiation.
export const STASH_INIT = 'STASH_INIT';

export const init = () => ({
  type: STASH_INIT,
});
